import axiosClient from '../configs/axios';


class TempoLoadingService {
    // Get list 
    async getTempoloadingList(params) {
        try {
            const response = await axiosClient.get(
                `/tempo_loading/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addTempoloading(data) {
        try {
            const response = await axiosClient.post('/tempo_loading/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteTempoloading(data) {
        try {
            const response = await axiosClient.put(`/tempo_loading/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new TempoLoadingService(); 